import {
    WorkbenchPlugin,
    WorkbenchPluginId, WorkbenchViewConfig, WorkbenchViewKind
} from '../../shared/types';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {faCamera, faVideo, faWrench, faClipboard} from '@fortawesome/pro-light-svg-icons';
import {TakeDeviceScreenshotViewComponent} from './views/take-device-screenshot-view.component';
import {WorkbenchCommandRegistry} from '../../shared/services/workbench-command-registry.service';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {WorkbenchToolService} from '../../shared/services/workbench-tool.service';
import {ImageService} from '@webmate-web-core/shared/services/image.service';
import {IndexedDbService} from '../../shared/services/indexed-db.service';
import {ScreenshotPlugin} from '../screenshot/screenshot-plugin';
import {DeviceToolsComponent} from './views/device-tools/device-tools.component';
import {WorkbenchClipboardViewComponent} from './views/workbench-clipboard-view.component';
import {StreamingQualityViewComponent} from './views/streaming-quality-view.component';
import {WorkbenchGpsViewComponent} from './views/workbench-gps-view.component';
import {LimitBandwidthViewComponent} from './views/limit-bandwidth-view.component';
import {WorkbenchBiometricsViewComponent} from './views/workbench-biometrics-view.component';
import {LogViewComponent} from './views/log-view.component';
import {WorkbenchGestureMetricsViewComponent} from './views/workbench-gesture-metrics-view.component';
import {TakeVideoSnippetViewComponent} from './views/take-video-snippet-view.component';
import {VideoRecordingPlugin} from '../video-recording/video-recording-plugin';
import {WorkbenchSpecialKeysViewComponent} from './views/workbench-special-keys-view.component';

@Injectable()
export class WorkbenchToolsPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'workbench-tools';
    views: WorkbenchViewKind[];

    static readonly LogViewId = 'workbench-tools.view.log';

    private viewContainerId = 'workbench-tools.viewcontainer';
    private secondaryViewContainerId = 'workbench-log.viewcontainer';

    constructor(private readonly commandRegistry: WorkbenchCommandRegistry,
                readonly layoutManager: WorkbenchLayoutManager,
                private readonly toolService: WorkbenchToolService,
                private readonly imageService: ImageService,
                private readonly indexedDbService: IndexedDbService) {
        super(layoutManager);
        this.views = [
            {
                id: WorkbenchToolsPlugin.LogViewId,
                component: LogViewComponent,
                name: 'Log',
                defaultViewContainer: this.secondaryViewContainerId,
            }
        ];
    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        // register view container for the Tools

        // this.layoutManager.registerViewContainer({
        //     type: 'NormalViewContainer',
        //     id: ViewContainerId,
        //     name: 'Workbench Tools',
        //     icon: {
        //         type: 'faIcon',
        //         instance: faWrench
        //     },
        //     allowedPanels: ['left-top', 'left-bottom'],
        //     defaultPanel: 'left-top',
        //     displayMode: 'stacked',
        //     toolbarCommandId: 'workbench-tools:toggleViewContainer'
        // });

        // register view container for the Log
        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: this.secondaryViewContainerId,
            name: 'Workbench Log',
            allowedPanels: ['bottom'],
            defaultPanel: 'bottom',
            displayMode: 'standalone',
            toolbarCommandId: 'workbench-log:toggleViewContainer'
        });

        // this.layoutManager.registerView({
        //     id: 'workbench-tools.view.screenshot',
        //     component: TakeDeviceScreenshotViewComponent,
        //     name: 'Screenshots',
        //     defaultViewContainer: ViewContainerId,
        // });
        //
        // this.layoutManager.registerView({
        //     id: 'workbench-tools.view.video-snippet',
        //     component: TakeVideoSnippetViewComponent,
        //     name: 'Video Recording',
        //     defaultViewContainer: ViewContainerId,
        // });

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.device-tools',
            component: DeviceToolsComponent,
            name: 'Device Tools',
            defaultViewContainer: ViewContainerId,
        });*/ //Is now implemented in the console toolbar

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.clipboard',
            component: WorkbenchClipboardViewComponent,
            name: 'Clipboard',
            defaultViewContainer: ViewContainerId,
        });*/ //Is now implemented in the console toolbar

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.streaming-quality',
            component: StreamingQualityViewComponent,
            name: 'Streaming Quality',
            defaultViewContainer: ViewContainerId,
        });*/ //Is now implemented in the console toolbar

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.gps',
            component: WorkbenchGpsViewComponent,
            name: 'GPS',
            defaultViewContainer: ViewContainerId,
        });*/  //Is now implemented in the console toolbar

        // this.layoutManager.registerView({
        //     id: 'workbench-tools.view.bandwidth',
        //     component: LimitBandwidthViewComponent,
        //     name: 'Limit Bandwidth',
        //     defaultViewContainer: ViewContainerId,
        // });

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.biometrics',
            component: WorkbenchBiometricsViewComponent,
            name: 'Biometrics',
            defaultViewContainer: ViewContainerId,
        });*/  //Is now implemented in the console toolbar

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.gesture-metrics',
            component: WorkbenchGestureMetricsViewComponent,
            name: 'Gesture Metrics',
            defaultViewContainer: ViewContainerId,
        });*/  //Is now implemented in the console toolbar

        /*this.layoutManager.registerView({
            id: 'workbench-tools.view.special-keys',
            component: WorkbenchSpecialKeysViewComponent,
            name: 'Special Keys',
            defaultViewContainer: ViewContainerId,
        });*/  //Is now implemented in the console toolbar

        // Toggles the Workbench Tools Container
        // this.commandRegistry.registerCommand(
        //     'workbench-tools:toggleViewContainer',
        //     {
        //         name: 'Workbench Tools',
        //         icon: {
        //             type: 'faIcon',
        //             instance: faWrench,
        //         },
        //         description: 'Toggle Workbench Tools View',
        //         statusBindings: {
        //             'active': {
        //                 'type': 'store',
        //                 'storeKey': 'viewcontainers.workbench-tools.viewcontainer.status.visible',
        //             }
        //         }
        //     },
        //     () => {
        //         this.layoutManager.toggleViewContainer('workbench-tools.viewcontainer', true);
        //     }
        // );

        // Toggles the Workbench Log Container
        this.commandRegistry.registerCommand(
            'workbench-log:toggleViewContainer',
            {
                name: 'Log',
                icon: {
                    type: 'faIcon',
                    instance: faClipboard,
                },
                description: 'Toggle Workbench Log View',
                statusBindings: {
                    'active': {
                        'type': 'store',
                        'storeKey': `viewcontainers.${this.secondaryViewContainerId}.status.visible`,
                    }
                }
            },
            () => {
                this.layoutManager.toggleViewContainer(this.secondaryViewContainerId, true);
            }
        );

        this.commandRegistry.registerCommand(
            'workbench:openLocalFile',
            {
                name: 'Open a locally dropped file in the Center View'
            },
            (params: { file: File }) => {
                const { file } = params;
                const mimeType = file.type;

                if (['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp'].includes(mimeType)) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const dataUrl = reader.result as string;
                        this.imageService.storeLocalScreenshot(dataUrl).subscribe(localScreenshotId => {
                            this.layoutManager.instantiateAndShowViewTemplate(
                                ScreenshotPlugin.ViewTemplateId,
                                { localScreenshotId, name: file.name }
                            );
                        });
                    };
                    reader.readAsDataURL(file);
                } else if (['video/mp4', 'video/webm'].includes(mimeType)) {
                    // Generate a stable ID from the file's identity so the same file dropped
                    // twice reuses the same IndexedDB entry and doesn't open a duplicate tab.
                    const localVideoBlobId = `local-video-${file.name}-${file.size}-${file.lastModified}`;
                    this.indexedDbService.addBlob(localVideoBlobId, file).subscribe(() => {
                        this.layoutManager.instantiateAndShowViewTemplate(
                            VideoRecordingPlugin.ViewTemplateId,
                            { localVideoBlobId, name: file.name, format: mimeType.replace('video/', '') }
                        );
                    });
                }
                // Unsupported types are silently ignored.
            }
        );

        this.commandRegistry.registerCommand(
            'workbench-tools:openScreenshot',
            {
                name: 'Open specific Screenshot in the Center View'
            },
            (params: any) => {
                const id = params.id;
                const localId = params.localId;
                const screenshotName = params.name;

                if (localId) {
                    this.layoutManager.instantiateAndShowViewTemplate(ScreenshotPlugin.ViewTemplateId, {
                        localScreenshotId: localId,
                        name: screenshotName
                    });
                } else if (id) {
                    this.layoutManager.instantiateAndShowViewTemplate(ScreenshotPlugin.ViewTemplateId, {id: id, name: screenshotName});
                }
            }
        );

        this.commandRegistry.registerCommand(
            'workbench-tools:openVideo',
            {
                name: "Open specific Video in the Center View"
            },
            (params: any) => {
                this.layoutManager.instantiateAndShowViewTemplate(VideoRecordingPlugin.ViewTemplateId, params);
            }
        );

        this.commandRegistry.registerCommand(
            'workbench-tools:downloadScreenshot',
            {
                name: 'Downloads a Screenshot'
            },
            (params: any) => {
                this.imageService.requestDownload({
                    name: params.name || 'screenshot',
                    imageId: params.id,
                    localScreenshotId: params.localId,
                    imageUrl: params.imageUrl,
                });
            }
        );

        this.commandRegistry.registerCommand(
            'workbench-tools:downloadVideoRecording',
            {
                name: "Downloads a Video Recording"
            },
            (params: {name: string, videoUrl: string}) => {
                const a = document.createElement('a');
                a.href = params.videoUrl;
                a.download = `${params.name}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        );

        this.commandRegistry.registerCommand(
            'workbench-tools:openScreenshotTool',
            {
                name: 'Opens the Screenshot Tool'
            },
            () => {
                if (!this.layoutManager.isViewContainerShown(this.viewContainerId)) {
                    this.layoutManager.showViewContainer(this.viewContainerId);
                }
                this.layoutManager.setExclusiveViewExpansionState('workbench-tools.view.screenshot', this.viewContainerId);
            }
        );

        this.commandRegistry.registerCommand(
            'workbench-tools:openVideoSnippetTool',
            {
                name: 'Opens the Screenshot Tool'
            },
            () => {
                if (!this.layoutManager.isViewContainerShown(this.viewContainerId)) {
                    this.layoutManager.showViewContainer(this.viewContainerId);
                }
                this.layoutManager.setExclusiveViewExpansionState('workbench-tools.view.video-snippet', this.viewContainerId);
            }
        );

        this.toolService.registerTool({
            id: 'screenshot',
            icon: faCamera,
            label: 'Open Screenshot Tool',
            command: 'workbench-tools:openScreenshotTool'
        });
        this.toolService.registerTool({
            id: 'video',
            icon: faVideo,
            label: 'Open Video Snippet Tool',
            command: 'workbench-tools:openVideoSnippetTool'
        });

        return of(undefined);
    }

}

